import { render, staticRenderFns } from "./add.vue?vue&type=template&id=60fd57aa&scoped=true"
import script from "./add.vue?vue&type=script&lang=js"
export * from "./add.vue?vue&type=script&lang=js"
import style0 from "./add.vue?vue&type=style&index=0&id=60fd57aa&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60fd57aa",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/jenkins/workspace/web-page/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('60fd57aa')) {
      api.createRecord('60fd57aa', component.options)
    } else {
      api.reload('60fd57aa', component.options)
    }
    module.hot.accept("./add.vue?vue&type=template&id=60fd57aa&scoped=true", function () {
      api.rerender('60fd57aa', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "found/views/cps/views/participant/blacklist/form/add.vue"
export default component.exports